import styled from 'styled-components';

export const StyledExcursionCardWrapper = styled.div`
  margin: 3rem auto;
`;
